import { Advertise } from 'layouts';

export default Advertise;
